// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__HkPDx","head":"ProcedureTableInfo_head__2tkOS"};